import { cn } from "@/utils/cn";

interface OnboardingUnitToggleProps<T extends string> {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

/** Dark segmented control of the v5 onboarding ("Segmented Control Action Sheet Dark" in Figma). */
export const OnboardingUnitToggle = <T extends string>({
  options,
  value,
  onChange,
}: OnboardingUnitToggleProps<T>) => (
  <div className="flex h-[52px] w-full items-center gap-2 rounded-[32px] bg-black/30 p-1">
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        className={cn(
          "flex h-full flex-1 items-center justify-center rounded-full text-sm font-medium",
          option.value === value ? "bg-white text-black" : "text-white",
        )}
      >
        {option.label}
      </button>
    ))}
  </div>
);
